import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { routes } from '../../constants.js/misc';
import { getOrderOrigin } from '../../utils/orderOrigin';

const OrderOriginLabel = ({ order }) => {
    const origin = getOrderOrigin(order);

    return (
        <div>
            <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                {origin.channelLabel}
            </Typography>
            {origin.isGateway ? (
                <Typography variant="body2" style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {origin.primaryLabel}
                </Typography>
            ) : origin.branchId ? (
                <Link
                    color="textSecondary"
                    variant="button"
                    style={{ whiteSpace: 'nowrap', fontWeight: 700 }}
                    component={RouterLink}
                    to={`${routes.updateUserStore}/${origin.branchId}`}
                >
                    {origin.primaryLabel}
                </Link>
            ) : (
                <Typography variant="caption">
                    <em>Sucursal eliminada</em>
                </Typography>
            )}
        </div>
    );
};

export default OrderOriginLabel;
